import { Field } from 'formik';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormikSelectComponent } from '../../../utilities/formUtils';
import { getFilteredVtypeForDD } from '../../vtype/data/selectors';


const TransTypeToRlbOptions = ({ name, isTxn, isLabel, label, isSelection, setOnSelect, placeholder, userProps, width, getvalue: callback, index, type, setFieldValue, values }, props) => {

    const getSelectedValue = (values) => {
        // console.log("Vtype Selected", values)
    }
    const options = useSelector(state => getFilteredVtypeForDD(state, props))


    // const options = [
    //     { key: 'All', text: 'All', value: 'All' },
    //     { key: 'VP', text: 'VP', value: 'VP' },
    //     { key: 'VS', text: 'VS', value: 'VS' },
    //     { key: 'VC', text: 'VC', value: 'VC' },
    //     { key: 'CI', text: 'CI', value: 'CI' },
    //     { key: 'CR', text: 'CR', value: 'CR' },
    //     { key: 'WI', text: 'WI', value: 'WI' },
    //     { key: 'WC', text: 'WC', value: 'WC' },
    //     { key: 'PP', text: 'PP', value: 'PP' },
    //     { key: 'EW', text: 'EW', value: 'EW' },
    //     { key: 'EWC', text: 'EWC', value: 'EWC' },
    //     { key: 'B', text: 'B', value: 'B' },
    //     { key: 'BC', text: 'BC', value: 'BC' },
    //     { key: 'PS', text: 'PS', value: 'PS' },
    //     { key: 'PC', text: 'PC', value: 'PC' },
    //     { key: 'CCP', text: 'CCP', value: 'CCP' },
    //     { key: 'CCPC', text: 'CCPC', value: 'CCPC' },
    //     { key: 'R', text: 'R', value: 'R' },
    //     { key: 'RC', text: 'RC', value: 'RC' },
    //     { key: 'STO', text: 'STO', value: 'STO' },
    //     { key: 'STI', text: 'STI', value: 'STI' },
    //     { key: 'STPI', text: 'STPI', value: 'STPI' },
    //     { key: 'STPR', text: 'STPR', value: 'STPR' },

    // ]

    useEffect(() => {
        setFieldValue(name, 'All')
    }, [])


    return (
        <Field name={name} isLabel={isLabel} isTxn={isTxn} label={label} isSelection={isSelection} component={FormikSelectComponent} userProps={{ options, getValue: getSelectedValue, index, placeholder }} placeholder={placeholder} width={width}> </Field>
    )

}


export default TransTypeToRlbOptions;